import { useRouter } from 'next/router';
import React from 'react';

import useIsLoggedIn from '@jpp/hooks/useIsLoggedIn';
import { EPageType } from 'common/typings/enums';

const useHasAccountAccess = () => {
  const isLoggedIn = useIsLoggedIn();
  const router = useRouter();

  React.useEffect(() => {
    if (!isLoggedIn) {
      router.replace(EPageType.Shop);
    }
  }, []);
};

export default useHasAccountAccess;
